import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesBySlug } from '@/mocks/articles';

export default function KakobuyNajlepszeZnajdzki() {
  return <ArticleLayout article={articlesBySlug['kakobuy-najlepsze-znajdzki']} />;
}